import {RootState} from '../indexReducers';

export const getAlert = (state: RootState) => state?.alertReducer?.alert;
